<template>
  <div>
    <div class="box">
      <div class="main">
        <div class="operation">
          <el-button @click="add" type="primary">+ 新建</el-button>
        </div>
        <!-- 表格内容 -->
        <div class="primary">
          <el-table height="600px" ref="multipleTable" :data="PurchaseList" tooltip-effect="dark"
            style="width: 100%;margin-bottom: 10px;" :header-cell-style="{
              color: '#333333',
              backgroundColor: 'rgb(240, 247, 253)',
            }" border>
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="100px" align="center"></el-table-column>
            <el-table-column prop="Name" label="组织名称" align="left"></el-table-column>
            <el-table-column label="地址URL" align="left">
              <template v-slot="{ row }">
                <a :href="row.LoginPageUrl" target="_blank">{{ row.LoginPageUrl }}</a>
              </template>
            </el-table-column>
            <el-table-column label="配置" width="180" align="left">
              <template slot-scope="scope">
                <el-button type="text" style="margin-right: 10px;font-size: 16px; color: #3978E7;font-weight: 400;"
                  @click="EditOrganization(scope.row)">编辑</el-button>
                <el-button style="font-size: 16px;color: #3978E7;font-weight: 400;" type="text"
                  @click="DeleteOrganization(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows"
              @pagination="OrganizationGetPageList"></Pagination>
          </div>
        </div>
      </div>
      <!-- 弹出框 -->
      <div class="add-procure">
        <el-dialog :visible.sync="addProcureDialog" width="840px" top="20vh" v-dialogDrag @close="handleClose">
          <div slot="title" class="header-title">
            <span class="title-name"></span>
            <span class="title-age">新增组织</span>
          </div>
          <div class="addOrganizationContent">
            <el-form label-width="auto" :model="PurchaseFrom" style="flex: 1;">
              <el-form-item label="组织名称">
                <!-- <el-input v-model="PurchaseFrom.Name"></el-input> -->
                <el-select v-model="PurchaseFrom.Name" filterable remote :remote-method="remoteMethod"
                  v-el-select-loadmore="loadmore" @change="change" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="(item, index) in hospital" :key="index" :label="item.Name" :value="item.Name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="网站LOGO">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
                  :on-change="handleLogo">
                  <img v-if="imageUrl.logo" :src="imageUrl.logo" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="标题图片">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
                  :on-change="handleHeader">
                  <img v-if="imageUrl.header" :src="imageUrl.header" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="背景图片">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
                  :on-change="handleBody">
                  <img v-if="imageUrl.body" :src="imageUrl.body" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="底部文字">
                <el-input placeholder="请输入底部文字" v-model="PurchaseFrom.RootText"></el-input>
              </el-form-item>
              <el-form-item label="语音服务地址">
                <el-input placeholder="请输入语音服务地址" v-model="PurchaseFrom.ServiceConfig"></el-input>
              </el-form-item>
            </el-form>
            <div>
              <img src="../../assets/image/login_show.png" alt="">
            </div>
          </div>
          <div class="btn">
            <button @click="Cancel">取消</button>
            <button @click="AddOrganizationData">保存</button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination/index.vue"
import administrators from "../../api/administrators"
import ProjectManagement from "../../api/ProjectManagement"
import apiLogin from "@/api/login";
export default {
  directives: {
    'el-select-loadmore': {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data() {
    return {
      listType: "",
      addProcureDialog: false,
      PurchaseList: [],
      PurchaseFrom: {
        Name: '',
        BindId: '',
        RootText: '',
        LogoImage: "",
        HeaderImage: "",
        BodyImage: "",
        ServiceConfig: ""
      },
      imageUrl: {
        logo: '',
        header: '',
        body: ''
      }, //回显图片
      type: 1,
      total: 0,
      listQuery: {
        page: 1,
        rows: 20,
      },
      hospital: [],
      listQueryAdd: {
        Key: '',
        page: 1,
        rows: 20
      },
      FD: null
    }
  },
  components: {
    Pagination
  },
  created() {
    this.OrganizationGetPageList()
  },
  methods: {
    handleLogo(file) { //处理LOGO图片
      const isJPG = file.raw.type === 'image/jpeg'
      const isPNG = file.raw.type === 'image/png'
      // const isLt2M = file.raw.size / 1024 / 1024 < 0.5  //限制上传文件的大小
      if (!isPNG && !isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      } else {
        this.imageUrl.logo = URL.createObjectURL(file.raw);//赋值图片的url，用于图片回显功能
        this.PurchaseFrom.LogoImage = file.raw
      }
    },
    handleHeader(file) { //处理Header图片
      const isJPG = file.raw.type === 'image/jpeg'
      const isPNG = file.raw.type === 'image/png'
      // const isLt2M = file.raw.size / 1024 / 1024 < 0.5  //限制上传文件的大小
      if (!isPNG && !isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      } else {
        this.imageUrl.header = URL.createObjectURL(file.raw);//赋值图片的url，用于图片回显功能
        this.PurchaseFrom.HeaderImage = file.raw
      }
    },
    handleBody(file) { //处理Body图片
      const isJPG = file.raw.type === 'image/jpeg'
      const isPNG = file.raw.type === 'image/png'
      // const isLt2M = file.raw.size / 1024 / 1024 < 0.5  //限制上传文件的大小
      if (!isPNG && !isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!')
        return false
      } else {
        this.imageUrl.body = URL.createObjectURL(file.raw);//赋值图片的url，用于图片回显功能
        this.PurchaseFrom.BodyImage = file.raw
      }
    },

    handleClose() {
      Object.keys(this.PurchaseFrom).forEach(i => {
        this.PurchaseFrom[i] = ""
      })
      Object.keys(this.imageUrl).forEach(i => {
        this.imageUrl[i] = ""
      })
      this.addProcureDialog = false;
    },
    //取消
    Cancel() {
      this.PurchaseFrom.Name = '';
      this.PurchaseFrom.BindId = '';
      this.addProcureDialog = false;
    },
    remoteMethod(name) {
      this.hospital = [];
      this.listQueryAdd.page = 1;
      this.Company(name);
    },
    //单位列表接口
    Company(name) {
      const parameter = {
        Key: name,
        page: this.listQueryAdd.page,
        rows: this.listQueryAdd.rows
      };
      ProjectManagement.GetPageListCompanyData(parameter).then(res => {
        if (res.data.Status == 1) {
          // this.hospital=res.data.Data
          res.data.Data.rows.forEach((item) => {
            this.hospital.push(item)
          })
        } else {
          alert(res.data.Message)
        }
      })
    },
    loadmore() {
      this.listQueryAdd.page += 1;
      this.Company();
    },
    add() {
      this.FD = new FormData()
      this.Company('')
      this.addProcureDialog = true
      this.type = 1
    },
    OrganizationGetPageList() {//列表
      const parameter = {
        Key: '',
        page: this.listQuery.page,
        rows: this.listQuery.rows
      }
      administrators.OrganizationGetPageListData(parameter).then(res => {
        if (res.data.Status == 1) {
          // console.log(res, "====");
          this.total = res.data.Data.total
          this.PurchaseList = res.data.Data.rows
        } else {
          alert(res.data.Message)
        }
      })
    },
    change(e) {
      this.hospital.forEach((item, index) => {
        if (item.Name == e) {
          this.PurchaseFrom.BindId = item.Id;
          this.PurchaseFrom.Name = e;
        }
      });
    },
    //添加组织和编辑
    AddOrganizationData(row) {
      if (this.PurchaseFrom.Name != "") {
        if (this.type == 1) {
          this.FD.append("Name", this.PurchaseFrom.Name)
          this.FD.append("BindId", this.PurchaseFrom.BindId)
          this.FD.append("RootText", this.PurchaseFrom.RootText)
          this.FD.append("LogoImage", this.PurchaseFrom.LogoImage)
          this.FD.append("HeaderImage", this.PurchaseFrom.HeaderImage)
          this.FD.append("BodyImage", this.PurchaseFrom.BodyImage)
          this.FD.append("ServiceConfig", this.PurchaseFrom.ServiceConfig)
          administrators.AddOrganizationData(this.FD).then(res => {
            if (res.data.Status == 1) {
              this.OrganizationGetPageList()
              this.PurchaseList.push(res.data.Data)
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.addProcureDialog = false
            } else {
              alert(res.data.Message)
            }
          })
        } else {
          this.FD.append("Name", this.PurchaseFrom.Name)
          this.FD.append("BindId", this.PurchaseFrom.BindId)
          this.FD.append("RootText", this.PurchaseFrom.RootText)
          this.FD.append("LogoImage", this.PurchaseFrom.LogoImage)
          this.FD.append("HeaderImage", this.PurchaseFrom.HeaderImage)
          this.FD.append("BodyImage", this.PurchaseFrom.BodyImage)
          this.FD.append("ServiceConfig", this.PurchaseFrom.ServiceConfig)
          this.FD.append("Id", this.PurchaseFrom.Id)
          administrators.EditOrganizationData(this.FD).then(res => {
            if (res.data.Status == 1) {
              this.OrganizationGetPageList()
              this.PurchaseList = this.PurchaseList.map(item => {
                if (item.Id == this.PurchaseFrom.Id) {
                  item = this.PurchaseFrom
                }
                return item
              })
              this.$message({
                message: '修改成功',
                type: 'success'
              });

              this.addProcureDialog = false
            } else {
              alert(res.data.Message)
            }
          })
        }
      }
    },
    //编辑
    EditOrganization(row) {
      this.FD = new FormData()
      this.type = 2
      // const regex = /[?&]id=([^&#]*)/;
      // const match = regex.exec(row.LoginPageUrl);
      // console.log(match);
      // const id = match && decodeURIComponent(match[1]);
      this.getDiyLogin(row.Id).then(r => {
        this.imageUrl.logo = r?.logoImageUrl
        this.imageUrl.header = r?.headerImageUrl
        this.imageUrl.body = r?.bodyImageUrl
        this.PurchaseFrom.RootText = r?.rootText
      })
      this.PurchaseFrom = JSON.parse(JSON.stringify(row));
      this.addProcureDialog = true
    },
    async getDiyLogin(id) {
      let res = await apiLogin.diyLogin(id)
      return res.data.Data.config.pageConfig
    },
    // 删除
    DeleteOrganization(row) {
      const parameter = []
      parameter.push(row.Id)
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        administrators.DeleteOrganizationData(parameter).then(res => {
          if (res.data.Status == 1) {
            this.PurchaseList = this.PurchaseList.filter(item => {
              return item.Id != row.Id
            })
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            alert(res.data.Message)
          }
        })
      })
    }
  },
}
</script>
<style lang='scss' scoped>
:deep(.el-dialog .el-dialog__header) {
  margin-bottom: 0;
}

.addOrganizationContent {
  display: flex;
  align-items: center;
  gap: 20px;

  &>div {
    img {
      width: 300px;
    }
  }

  &>form {
    & .el-form-item {
      position: relative;
    }

    & .el-form-item:nth-of-type(2) {
      &::after {
        content: "建议上传尺寸100*100px";
        position: absolute;
        top: 30%;
        left: 50%;
        color: #999999;
      }
    }

    & .el-form-item:nth-of-type(3) {
      &::after {
        content: "建议上传尺寸900*90px";
        position: absolute;
        top: 30%;
        left: 50%;
        color: #999999;
      }
    }

    & .el-form-item:nth-of-type(4) {
      &::after {
        content: "建议上传尺寸1920*540px";
        position: absolute;
        top: 30%;
        left: 50%;
        color: #999999;
      }
    }
  }

}

:deep(.el-dialog) {
  margin-top: 10vh !important;
}

.box {
  width: 100%;
  padding: 20px 40px 40px 40px;
  box-sizing: border-box;
  height: 745px;

  .operation {
    margin-bottom: 20px;
  }

  // /deep/.el-input__inner{
  //   width: 380px;
  // }
}

:deep(.avatar-uploader .el-upload) {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

:deep(.avatar-uploader .el-upload:hover) {
  border-color: #409EFF;
}

:deep(.avatar-uploader-icon) {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

:deep(.avatar) {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
